import React, { ReactNode } from "react";
import { Box, Button, Grid } from "@mui/material";
import ListItem from "./ListItem";
import { Add } from "@mui/icons-material";

interface ListProps<T> {
  heading: string;
  addButtonLabel: string;
  items: T[];
  render: (item: T, index: number) => ReactNode;
  onAddItem?: () => void;
  onRemoveItem?: (item: T, index: number) => void;
  disabled?: boolean;
  children?: ReactNode;
}

const List = <T extends object>({
  heading,
  addButtonLabel,
  items,
  render,
  onAddItem,
  onRemoveItem,
  disabled,
}: ListProps<T>) => {
  return (
    <>
      <Grid item xs={12}>
        {items.map((item, index) => (
          <ListItem<T>
            key={index}
            item={item}
            index={index}
            onRemove={onRemoveItem}
          >
            {render(item, index)}
          </ListItem>
        ))}
      </Grid>
      <Grid item xs={12}>
        <Box textAlign="center">
          <Button
            color="primary"
            variant="contained"
            size="medium"
            endIcon={<Add />}
            disabled={disabled}
            onClick={onAddItem}
            style={{ marginTop: "15px" }}
          >
            {addButtonLabel}
          </Button>
        </Box>
      </Grid>
    </>
  );
};

export default List;
